// Vendor Libraries
import { ElementRef, NgZone } from '@angular/core';
import { downloadUrl } from 'NewAngular/utils/download';
import Sortable from 'sortablejs';
// Utils / constants
import { disablePointerEvents, enablePointerEvents } from 'NewAngular/utils/sortable-utils';
import { DATA_EXPORT_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { StressTestService } from 'StressTestsApp/ts/services/stress-test-service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "StressTestsApp/ts/services/stress-test-service";
import * as i3 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i4 from "../../../../../../../../search/static/search/ts/features/autocomplete-in-place/security-autocomplete-in-place.component";
import * as i5 from "@angular/common";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i7 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i8 from "../../../../../../../../companies/static/companies/ts/features/format-menu/format-menu.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i10 from "../../../../../../../../securities/static/securities/ts/features/module-upsell/module-upsell.component";
import * as i11 from "../../../../../../../../securities/static/securities/ts/features/performance-include-benchmark-checkbox/performance-include-benchmark-checkbox";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/side-menu/side-menu.component";
import * as i13 from "StressTestsApp/ts/features/stress-test-manage-modal/stress-test-manage-modal.component";
import * as i14 from "../stress-test-chart/stress-test-chart.component";
const _c0 = ["sortableContainer"];
function StressTestComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "div", 21);
    i0.ɵɵelementEnd();
} }
function StressTestComponent__svg_svg_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-export");
} }
function StressTestComponent_div_10_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "label", 26);
    i0.ɵɵtext(2, " Format ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 37);
    i0.ɵɵelement(4, "ycn-format-menu", 38);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("config", ctx_r3.formatOptions)("format", ctx_r3.format)("userPreferenceName", ctx_r3.userPreferenceKeys.format);
} }
function StressTestComponent_div_10_ycn_performance_include_benchmark_checkbox_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-performance-include-benchmark-checkbox", 39);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("userPreferenceKeys", ctx_r3.userPreferenceKeys);
} }
function StressTestComponent_div_10_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "div", 21);
    i0.ɵɵelementEnd();
} }
function StressTestComponent_div_10__svg_svg_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-export");
} }
function StressTestComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23)(2, "div", 24)(3, "div", 25)(4, "div", 26);
    i0.ɵɵtext(5, "Comparison Security");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 27)(7, "ycn-security-autocomplete-in-place", 28);
    i0.ɵɵlistener("removeHandler", function StressTestComponent_div_10_Template_ycn_security_autocomplete_in_place_removeHandler_7_listener() { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.removeComparisonSecurity()); })("submitHandler", function StressTestComponent_div_10_Template_ycn_security_autocomplete_in_place_submitHandler_7_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.updateComparisonSecurity($event)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(8, StressTestComponent_div_10_div_8_Template, 5, 3, "div", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 30)(10, "div", 31)(11, "div", 25);
    i0.ɵɵtemplate(12, StressTestComponent_div_10_ycn_performance_include_benchmark_checkbox_12_Template, 1, 1, "ycn-performance-include-benchmark-checkbox", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 33)(14, "button", 34);
    i0.ɵɵlistener("click", function StressTestComponent_div_10_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r3); i0.ɵɵnextContext(); const stressTestManageModal_r2 = i0.ɵɵreference(21); return i0.ɵɵresetView(stressTestManageModal_r2.openModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(15, "svg", 9);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(16, "span");
    i0.ɵɵtext(17, "Manage");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "button", 35);
    i0.ɵɵlistener("click", function StressTestComponent_div_10_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.download()); });
    i0.ɵɵtemplate(19, StressTestComponent_div_10_div_19_Template, 2, 0, "div", 10)(20, StressTestComponent_div_10__svg_svg_20_Template, 1, 1, "svg", 11);
    i0.ɵɵelementStart(21, "span");
    i0.ɵɵtext(22, "Export");
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("appendToBody", true)("displayIdentifier", ctx_r3.comparisonSecurityId)("searchType", "securities_with_calcs")("buttonType", "icon-search")("showRemove", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.format);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r3.benchmarkDisabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-gear");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r3.hasExportFeature);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.downloading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.downloading);
} }
function StressTestComponent_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 40);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r3.comparisonSecurityLegendName);
} }
function StressTestComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 41);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("bullet-3", ctx_r3.comparisonSecurityId)("bullet-2", !ctx_r3.comparisonSecurityId);
    i0.ɵɵproperty("textContent", ctx_r3.benchmarkLegendName);
} }
function StressTestComponent_div_15_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43)(1, "ycn-stress-test-chart", 44);
    i0.ɵɵlistener("deleteStressTestHandler", function StressTestComponent_div_15_div_2_Template_ycn_stress_test_chart_deleteStressTestHandler_1_listener() { const ctx_r5 = i0.ɵɵrestoreView(_r5); const stressTest_r7 = ctx_r5.$implicit; const i_r8 = ctx_r5.index; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.deleteStressTest(stressTest_r7.id, i_r8)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const stressTest_r7 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("calcs", ctx_r3.calcs)("stressTest", stressTest_r7)("format", ctx_r3.format)("chartTabUrl", ctx_r3.chartTabUrl);
} }
function StressTestComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24, 2);
    i0.ɵɵtemplate(2, StressTestComponent_div_15_div_2_Template, 2, 4, "div", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.stressTests);
} }
function StressTestComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45)(1, "div", 46);
    i0.ɵɵelement(2, "div", 47)(3, "div", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 49);
    i0.ɵɵelement(5, "ycn-module-upsell", 50);
    i0.ɵɵelementStart(6, "div", 51);
    i0.ɵɵtext(7, "No data available");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "table", 52)(9, "tbody")(10, "tr")(11, "td");
    i0.ɵɵtext(12, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "tr")(14, "td");
    i0.ɵɵtext(15, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "tr")(17, "td");
    i0.ɵɵtext(18, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "tr")(20, "td");
    i0.ɵɵtext(21, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "tr")(23, "td");
    i0.ɵɵtext(24, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "tr")(26, "td");
    i0.ɵɵtext(27, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "tr")(29, "td");
    i0.ɵɵtext(30, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "tr")(32, "td");
    i0.ɵɵtext(33, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "tr")(35, "td");
    i0.ɵɵtext(36, "\u00A0");
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("title", "Stress Test");
} }
export class StressTestComponent {
    constructor(eltRef, accountsService, stressTestService, featureService, ngZone) {
        this.eltRef = eltRef;
        this.accountsService = accountsService;
        this.stressTestService = stressTestService;
        this.featureService = featureService;
        this.ngZone = ngZone;
        this.userPreferenceKeys = {};
        this.benchmarkDisabled = false;
        this.comparisonSecurityLegendName = '';
        this.USER = window.USER;
        this.stressTests = JSON.parse(eltRef.nativeElement.getAttribute('stressTests'));
        this.allStressTests = JSON.parse(eltRef.nativeElement.getAttribute('allStressTests'));
        this.userPreferenceKeys = JSON.parse(eltRef.nativeElement.getAttribute('userPreferenceKeys'));
        this.formatOptions = JSON.parse(eltRef.nativeElement.getAttribute('formatOptions'));
        const securityName = eltRef.nativeElement.getAttribute('securityName');
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.title = `${securityName} Stress Test`;
        this.chartTabUrl = eltRef.nativeElement.getAttribute('chartTabUrl');
        this.securityLegendName = eltRef.nativeElement.getAttribute('securityLegendName');
        this.benchmarkLegendName = eltRef.nativeElement.getAttribute('benchmarkLegendName');
        this.benchmarkSelected = this.benchmarkLegendName !== 'None';
        this.comparisonSecurityLegendName = eltRef.nativeElement.getAttribute('comparisonSecurityLegendName');
        this.comparisonSecurityId = eltRef.nativeElement.getAttribute('comparisonSecurityId');
        this.format = eltRef.nativeElement.getAttribute('format');
        this.calcs = JSON.parse(eltRef.nativeElement.getAttribute('calcs'));
        this.stressTestTabUrl = eltRef.nativeElement.getAttribute('stressTestTabUrl');
        this.benchmarkDisabled = JSON.parse(eltRef.nativeElement.getAttribute('benchmarkDisabled') ?? 'false');
        if (this.benchmarkDisabled)
            this.benchmarkSelected = false;
        this.hasExportFeature = this.featureService.userHasFeatures([DATA_EXPORT_FEATURE]);
    }
    ngAfterViewInit() {
        this.initializeSortable();
    }
    updateComparisonSecurity(autocompleteResult) {
        this.comparisonSecurityLegendName = `${autocompleteResult.name} (${autocompleteResult.display_security_id})`;
        this.comparisonSecurityId = autocompleteResult.search_id;
        window.location.href = `${this.stressTestTabUrl}?comparison_security_symbol=${this.comparisonSecurityId}`;
    }
    removeComparisonSecurity() {
        this.comparisonSecurityLegendName = '';
        this.comparisonSecurityId = '';
        window.location.href = this.stressTestTabUrl;
    }
    download() {
        this.downloading = true;
        this.stressTestService.getPDFExport(this.securityId, this.comparisonSecurityId).subscribe({
            next: (response) => {
                this.downloading = false;
                downloadUrl(response.pdf_url);
            },
            error: () => {
                this.downloading = false;
            },
        });
    }
    deleteStressTest(stressTestId, index) {
        this.stressTestService.deleteStressTest(stressTestId).subscribe(() => { });
        this.stressTests.splice(index, 1);
    }
    updateOrdering(oldIndex, newIndex) {
        this.stressTests.splice(newIndex, 0, this.stressTests.splice(oldIndex, 1)[0]);
        const stressTest = this.allStressTests.find((_) => _.id === this.stressTests[newIndex].id);
        if (stressTest) {
            if (newIndex === 0) {
                stressTest.order = this.stressTests[newIndex + 1].order - 0.5;
            }
            else {
                stressTest.order = this.stressTests[newIndex - 1].order + 0.5;
            }
        }
        this.allStressTests.sort((a, b) => a.order - b.order);
        this.allStressTests = this.allStressTests.map((test, index) => ({ ...test, order: index }));
        this.stressTestService.updateStressTests({ stress_tests: this.allStressTests }).subscribe((stressTests) => {
            stressTests.forEach((test) => {
                const st = this.stressTests.find((_) => _.id === test.id);
                if (st) {
                    st.order = test.order;
                }
            });
        });
    }
    addStressTests(stressTestTemplates) {
        if (!stressTestTemplates.length) {
            window.location.reload();
            return;
        }
        const stressTestsToAdd = stressTestTemplates
            .filter((template) => !this.stressTests.some((test) => test.shortName === template.name))
            .map((template, index) => ({ ...template, order: this.stressTests.length + index }));
        this.stressTestService.createStressTests({ stress_tests: stressTestsToAdd }).subscribe(() => {
            window.location.reload();
        });
    }
    reloadStressTests() {
        window.location.reload();
    }
    initializeSortable() {
        if (this.sortableContainer?.nativeElement) {
            const className = 'chart-panel';
            this.ngZone.runOutsideAngular(() => {
                Sortable.create(this.sortableContainer.nativeElement, {
                    handle: '.btn-move',
                    scroll: false,
                    forceFallback: true,
                    animation: 150,
                    onUpdate: (evt) => {
                        // The Sortable library is outside our Angular context, so we need to wrap
                        // our handler in a ngZone.run statement so that we are within a digest cycle.
                        this.ngZone.run(() => {
                            this.updateOrdering(evt.oldIndex, evt.newIndex);
                        });
                    },
                    onStart: () => {
                        disablePointerEvents(document, className);
                    },
                    onEnd: () => {
                        enablePointerEvents(document, className);
                    },
                });
            });
        }
    }
}
StressTestComponent.ɵfac = function StressTestComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StressTestComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.StressTestService), i0.ɵɵdirectiveInject(i3.FeatureService), i0.ɵɵdirectiveInject(i0.NgZone)); };
StressTestComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StressTestComponent, selectors: [["ycn-stress-test"]], viewQuery: function StressTestComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortableContainer = _t.first);
    } }, standalone: false, decls: 22, vars: 11, consts: [["featureNeededModal", ""], ["stressTestManageModal", ""], ["sortableContainer", ""], [1, "page-body"], [1, "page-header"], [1, "page-title"], [1, "page-name", 3, "textContent"], [1, "form-inline"], [1, "btn", "btn-secondary", "hidden-md", "ml-20", 3, "click"], ["ycnIcon", "", 3, "name"], ["class", "mr-1 ng-scope", 4, "ngIf"], ["ycnIcon", "", 3, "name", 4, "ngIf"], ["class", "row align-items-end", 4, "ngIf"], [1, "d-flex", "flex-wrap", "mb-2"], [1, "chart-legend-item-title", "text-uppercase", "bullet-1", "mr-20", 3, "textContent"], ["class", "chart-legend-item-title text-uppercase bullet-2 mr-20", 3, "textContent", 4, "ngIf"], ["class", "chart-legend-item-title text-uppercase", 3, "bullet-3", "bullet-2", "textContent", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "panel panel-data", "data-test-id", "zero-stress-tests", 4, "ngIf"], [3, "submitModalHandler", "stressTests"], [1, "mr-1", "ng-scope"], [1, "loader-spinner-context", "loader-xs"], [1, "row", "align-items-end"], [1, "col-md-auto", "mb-2"], [1, "row"], [1, "col"], [1, "label", "form-label", "form-label-thin"], [1, "mt-1"], ["data-test-id", "comparison-security-autocomplete", 3, "removeHandler", "submitHandler", "appendToBody", "displayIdentifier", "searchType", "buttonType", "showRemove"], ["class", "col-auto", 4, "ngIf"], [1, "col-md", "col", "mb-2"], [1, "row", "align-items-center"], ["class", "panel-action", 3, "userPreferenceKeys", 4, "ngIf"], [1, "col-auto", "visible-md-flex", "form-inline"], [1, "btn", "btn-secondary", 3, "click"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], [1, "col-auto"], [1, "dropdown", "mt-1"], [3, "config", "format", "userPreferenceName"], [1, "panel-action", 3, "userPreferenceKeys"], [1, "chart-legend-item-title", "text-uppercase", "bullet-2", "mr-20", 3, "textContent"], [1, "chart-legend-item-title", "text-uppercase", 3, "textContent"], ["class", "col-6 chart-panel", "data-test-id", "stress-test", 4, "ngFor", "ngForOf"], ["data-test-id", "stress-test", 1, "col-6", "chart-panel"], [3, "deleteStressTestHandler", "calcs", "stressTest", "format", "chartTabUrl"], ["data-test-id", "zero-stress-tests", 1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-content"], [3, "title"], [1, "panel-data-empty-message"], [1, "table"]], template: function StressTestComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5);
        i0.ɵɵelement(3, "h1", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 7)(5, "button", 8);
        i0.ɵɵlistener("click", function StressTestComponent_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r1); const stressTestManageModal_r2 = i0.ɵɵreference(21); return i0.ɵɵresetView(stressTestManageModal_r2.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(7, "button", 8);
        i0.ɵɵlistener("click", function StressTestComponent_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.download()); });
        i0.ɵɵtemplate(8, StressTestComponent_div_8_Template, 2, 0, "div", 10)(9, StressTestComponent__svg_svg_9_Template, 1, 1, "svg", 11);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(10, StressTestComponent_div_10_Template, 23, 11, "div", 12);
        i0.ɵɵelementStart(11, "div", 13);
        i0.ɵɵelement(12, "span", 14);
        i0.ɵɵtemplate(13, StressTestComponent_span_13_Template, 1, 1, "span", 15)(14, StressTestComponent_span_14_Template, 1, 5, "span", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, StressTestComponent_div_15_Template, 3, 1, "div", 17)(16, StressTestComponent_div_16_Template, 37, 1, "div", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(17, "ycn-side-menu")(18, "ycn-feature-needed", null, 0);
        i0.ɵɵelementStart(20, "ycn-stress-test-manage-modal", 19, 1);
        i0.ɵɵlistener("submitModalHandler", function StressTestComponent_Template_ycn_stress_test_manage_modal_submitModalHandler_20_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.reloadStressTests()); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.title);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", "icon-gear");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.downloading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.downloading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.USER.authenticated);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", ctx.securityLegendName);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.comparisonSecurityId);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.benchmarkSelected);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.stressTests == null ? null : ctx.stressTests.length);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !(ctx.stressTests == null ? null : ctx.stressTests.length));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("stressTests", ctx.allStressTests);
    } }, dependencies: [i4.SecurityAutocompleteInPlaceComponent, i5.NgForOf, i5.NgIf, i6.DisabledDirective, i7.FeatureNeededComponent, i8.FormatMenuComponent, i9.IconDirective, i10.ModuleUpsellComponent, i11.PerformanceIncludeBenchmarkCheckboxComponent, i12.SideMenuComponent, i13.StressTestManageModalComponent, i14.StressTestChartComponent], encapsulation: 2 });
